import BidRow from "./bidRow";
import { formatDecimalPlace, formatUTCDate, getShortMonthName } from 'common/formatters';
import { renderFuturesChange } from "./BidColumnRenderers";
import { Unit } from "domain/unit";
import { convertPriceToSelectedUnit, roundBid } from "external/helper";

export const ColumnIds = {
    Name: "name",
    Date: "date",
    Month: "month",
    Basis: "basis",
    Cash: "cash",
    Price: "price",
    Change: "change"
}

export interface BidColumn {
    key: string;
    name: string;
    renderer: BidCellRenderer;
}

export type BidCellRenderer = (m: BidRow, u: Unit) => React.ReactNode;

export const bidColumns: { [name: string]: BidColumn } = {};

buildColumn(ColumnIds.Name, "Delivery Period", m => m.deliveryPeriodName ?? '--');
buildColumn(ColumnIds.Date, "Dates", m => `${formatUTCDate(m.start)}-${formatUTCDate(m.end)}`);
buildColumn(ColumnIds.Month, "Fut Mo", m => m.futuresMonth ? `${getShortMonthName(m.futuresMonth)} ${m.futuresYear - 2000}` : '--');
buildColumn(ColumnIds.Price, "Futures", m => m.futuresPrice ? `${formatDecimalPlace(m.futuresPrice)}${m.isSettled ? ' s' : ''}` : '--');
buildColumn(ColumnIds.Basis, "Basis", (m, u) => m.basis ? formatDecimalPlace(convertPriceToSelectedUnit(m.basis, m.commodity, u)) : '--');
buildColumn(ColumnIds.Cash, "Cash", (m, u) => m.cash ? formatDecimalPlace(roundBid(m.cash, m.isSettled, m.commodity, u)) : '--');
buildColumn(ColumnIds.Change, "Fut Chg", renderFuturesChange);

function buildColumn(key: string, name: string, renderer: BidCellRenderer) {
    bidColumns[key] = {
        key: key,
        name: name,
        renderer: renderer
    };
}

export const defaultColumns = [
    ColumnIds.Date,
    ColumnIds.Month,
    ColumnIds.Price,
    ColumnIds.Basis,
    ColumnIds.Cash,
    ColumnIds.Change
];